import { useApp } from "../context/AppContext";
import { SignInForm } from "./SignInForm";

export function SignInPanel() {
  const { signInPanelOpen, closeSignInPanel } = useApp();

  if (!signInPanelOpen) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(42,29,20,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 100,
        padding: 24,
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) closeSignInPanel();
      }}
    >
      <div
        style={{
          background: "var(--paper)",
          border: "1px solid var(--line)",
          padding: 32,
          maxWidth: 440,
          width: "100%",
          borderRadius: 4,
          boxShadow: "var(--shadow)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
          <h2 className="serif" style={{ margin: 0, fontSize: 32 }}>
            Sign in
          </h2>
          <button
            onClick={closeSignInPanel}
            style={{ background: "none", border: "none", fontSize: 22, color: "var(--ink-soft)", cursor: "pointer" }}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <SignInForm subtitle="No password. We'll email you a one-time link to sign in." />
      </div>
    </div>
  );
}
